import './App.css';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Testimonials from './components/Testimonials';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import React, { useEffect, useState } from "react";


function App() {

  // ✅ STATE
  const [showTop, setShowTop] = useState(false);

  // ✅ EFFECT
  useEffect(() => {
    const handleScroll = () => {
      setShowTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  return (
    <div className="body">
      <Navigation />
      <Hero />
      {/* <Logo /> */}
      <About />
      <Services />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />

      <a
        href="https://wa.me/27828179265?text=Hi%2C%20please%20tell%20me%20more%20about%20your%20services."
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        💬
      </a>

      {/* Back to Top Button (conditional) */}
      {showTop && (
        <button
          className="back-to-top"
          onClick={() =>
            window.scrollTo({ top: 0, behavior: "smooth" })
          }
        >
          ↑
        </button>
      )}

    </div>
  );

}

export default App;
